import { useDispatch } from 'react-redux';

import { useQuery } from '@tanstack/react-query';
import { AccountRelationsDetailsApiDtoClm } from 'types/BusinessRelationship';
import { AxiosError } from 'axios';
import { openModal } from 'reducers/modalReducer';
import brService from 'services/brService';

export const useFetchBrDetails = (brUid: string, usedInBr: boolean) => {
  const dispatch = useDispatch();
  return useQuery<AccountRelationsDetailsApiDtoClm, AxiosError>({
    queryKey: ['getBrDetails', brUid],
    queryFn: () => brService.getBusinessRelationship(brUid),
    enabled: usedInBr,
    onError: (error: AxiosError) =>
      dispatch(
        openModal({
          modalType: 'ErrorDialog',
          modalProps: { error },
        }),
      ),
  });
};
